/* eslint-disable */
// Helpers de formatação do pacote "ginfo-regras-pacote" (ver tutorialMock.js
// e TutorialModal.vue). O texto vindo do backend pode conter **negrito** e
// quebras de linha (\n) - aqui ele é escapado antes de virar HTML, pra não
// abrir brecha de XSS caso o conteúdo tenha algo digitado sem cuidado.

function escaparHtml(texto) {
  return String(texto)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export function formatarTexto(texto) {
  if (!texto) return ''
  return escaparHtml(texto).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
}

const CLASSES_TOM = {
  ok: 'tom-ok',
  nok: 'tom-nok',
  warn: 'tom-warn',
  info: 'tom-info'
}

export function classeTom(tom) {
  return CLASSES_TOM[tom] || 'tom-neutro'
}
